import React from "react";
import Box from "@mui/material/Box";
import sanitizeMemoHtml from "../utils/sanitizeMemoHtml";

/**
 * Renders stored memo HTML safely. Always routes through sanitizeMemoHtml so no
 * display can forget to sanitize. `white-space: pre-wrap` keeps legacy
 * plain-text memos (with literal newlines) rendering correctly alongside
 * rich-text ones.
 *
 * The containment rules below are the second half of the pasted-markup defense
 * sanitizeMemoHtml starts: it drops foreign inline sizing, and these cap
 * anything sized by a stylesheet class or an HTML width= attribute it cannot
 * see, so a memo can never widen the card it sits in.
 *
 * Pass `component` to control the element (defaults to a <div>) and `sx` for
 * styling; any other props (e.g. MUI Typography's `variant`) are forwarded.
 */
export default function MemoContent({ html, component = "div", sx, ...props }) {
    return (
        <Box
            component={component}
            sx={{
                whiteSpace: "pre-wrap",
                maxWidth: "100%",
                overflowX: "hidden",
                overflowWrap: "anywhere",
                "& *": { maxWidth: "100%", boxSizing: "border-box" },
                "& img": { height: "auto" },
                ...sx,
            }}
            dangerouslySetInnerHTML={{ __html: sanitizeMemoHtml(html) }}
            {...props}
        />
    );
}
